import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core'
import { provideState } from '@ngrx/store'
import { provideEffects } from '@ngrx/effects'

import { RankingsApi } from './api/rankings.api'
import { RANKINGS_FEATURE_TOKEN } from './constants/rankings.constants'
import { rankingsReducer } from './store/reducers/ranking.reducer'
import { RankingEffects } from './store/effects/ranking.effects'

export function provideRankings(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(RANKINGS_FEATURE_TOKEN, rankingsReducer),
    provideEffects([RankingEffects]),
    RankingsApi
  ])
}
